export class TeamFormSummary {
  public id: string;
  public title: string;
  public templateName: string;
  public createdOn: Date;
  public deadline: Date;
  public totalSent: number;
  public totalCompleted: number;
  public hasExpired: boolean;

  public static parse(data: any): TeamFormSummary {
    if (!data) return null;

    let teamFormSummary = new TeamFormSummary();
    Object.assign(teamFormSummary, data);

    return teamFormSummary;
  }
}
